module.exports = __webpack_public_path__ + "static/media/Avenir-Black.bab406df.woff";